// Function to check and add class
function addParentClassForAccountsHub() {
  const hub = document.querySelector('accounts-hub');
  if (hub && hub.parentElement && !hub.parentElement.classList.contains('c-hub-parent')) {
    hub.parentElement.classList.add('c-hub-parent');
    console.log('✅ Added class c-hub-parent to parent of accounts-hub');
  }
}

// Run initially in case it's already present
addParentClassForAccountsHub();

// Observe DOM changes (for dynamically loaded elements)
const observer = new MutationObserver(() => {
  addParentClassForAccountsHub();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
